export const projectedX = "x"
export const projectedY = "y"
export const projectedYMiddle = "yMiddle"
export const projectedYTop = "yTop"
export const projectedYBottom = "yBottom"
export const projectedXMiddle = "xMiddle"
export const projectedXTop = "xTop"
export const projectedXBottom = "xBottom"
